import React, { useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
} from "@screens/inventory/inventory-manufacturer/manufacturer-list/model/manufacturer-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
  getParamsData,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import {
  deleteDataApi,
  getDataApi,
} from "./manufacturer-list.component.service";
import ManufacturerListTemplateComponent from "./manufacturer-list-template.component";
import { useEffect } from "react";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  MANUFACTURER_ALERTS: { DELETE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const ManufacturerListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const tableParams = getParamsData(filterList, menuUrl);
  const [filterState, setFilterState] = useState(filters);
  const { appRowsPerPage } = useSelector((state) => state.app);

  const getManufacturerData = async (params = null) => {
    console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const manufacturerData = await getDataApi({
      ...params,
      filters: queryStr,
    });
    if (manufacturerData.status) {
      console.log({manufacturerData});
      setTableData(manufacturerData.data);
      setTotalCount(manufacturerData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getManufacturerData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: appRowsPerPage || ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const submitFilter = (filters) => {
      const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
      console.log({ queryStr });
      getManufacturerData({
        orderBy: "created_at",
        sortBy: "desc",
        skip: 0,
        limit: appRowsPerPage || ROWS_PER_PAGE,
        filters: queryStr,
      });
    };

  const onLoad = async () => {
    const copyFilters = rawFilters();
    setFilterState(copyFilters);
  };

  useEffect(() => {
    onLoad();
  }, []);


  return menuAccess ? (
    <ManufacturerListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        filters: filterState,
        tableParams,
      }}
      templateEvents={{
        getManufacturerData,
        handleCreateClick,
        deleteRecords,
        submitFilter,
        // handleDownload,
      }}
    />
  ) : (
    <> </>
  );
};

export default ManufacturerListComponent;